export default class StringUtil {
  public static stringToUpperSnakeCase(strValue: string):string {
    return strValue
      .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
      .map((x) => x.toUpperCase())
      .join("_");
  }
  public static capitalizeFirstLetter(strValue: string):string {
    return strValue.charAt(0).toUpperCase() + strValue.slice(1);
  }
  public static normalizeFieldName(field: string): string {
    return field
      .replace(/^\//, "")
      .toLowerCase();
  }
  public static checkUpperCase(sName: string): boolean {
    if (!sName) return false;
    return sName.toUpperCase() === sName;
  }
  public static addWildcards(value: string): string {
      if (!value.startsWith("*")) value = "*" + value;
      if (!value.endsWith("*")) value += "*";
      return value;
  }

}